import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { AuthorInfoComponent } from '@core/components/author-info/author-info.component';
import { PipesModule } from '@core/pipes/pipes.module';
import { OnUiCoverModule } from 'onclass-ui';
import { BaseContentCardMiniComponent } from '../../../content-card-mini/base-content-card-mini.component';

@Component({
  selector: 'app-new-content-card',
  templateUrl: './new-content-card.component.html',
  styleUrls: ['./new-content-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, OnUiCoverModule, PipesModule, RouterModule, AuthorInfoComponent],
})
export class NewContentCardComponent extends BaseContentCardMiniComponent {
  public schemaOrgItemType: string;

  protected onChanged(): void {
    this.detectChanges();
  }

  protected prepareContentCard() {
    super.prepareContentCard();

    if (this.isVideo) {
      this.schemaOrgItemType = 'https://schema.org/MediaObject';
    } else if (this.isAudio) {
      this.schemaOrgItemType = 'https://schema.org/PodcastEpisode';
    } else if (this.isImage) {
      this.schemaOrgItemType = 'https://schema.org/MediaObject';
    } else {
      this.schemaOrgItemType = 'https://schema.org/Article';
    }
  }
}
